import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const TermConditionPublic = () => {
 
   const [iState,setIState] = useState({});
 
  useEffect(() => {
   async function getPrivacyPolicy() {
     try {
       const response = await axios.get(
         "https://quixnews.com/api/v1/customer/termcheck"
       );
 
       const details = response.data?.data?.[0];
       console.log("Privacy details:", details);
 
       setIState(details);
     } catch (error) {
       console.error("Error fetching privacy policy:", error);
     }
   }
 
   getPrivacyPolicy();
 }, []);
 
 
   return (
      
      <div style={{padding:"20px 20px",backgroundColor:"#fff",width:"100%",height:"100%"}}> 
        <div style={{fontSize:'22px',fontWeight:'700',textDecoration:'underline',marginBottom:'20px',textAlign:'center'}}>Please Read Carefully</div>
        <Link  class="btn btn-primary" to={"/login"} style={{marginBottom:'20px',float:"right"}}>Back</Link>
        <div>
         <div style={{fontSize:'22px',fontWeight:'600',marginBottom:'20px'}}>Term & Condition</div>
        </div>
       <div dangerouslySetInnerHTML={{ __html: iState?.details }}/>
       </div>
   )
 }
 

export default TermConditionPublic